import { QueryFunctionContext } from '@tanstack/react-query'

import { HttpGet } from '@tabeeb/shared/utils/API/httpClient'
import {
  GetReadonlyContentFormsResponse,
  GetReadonlyContentResponse,
  ReadonlyFormAnswerResponse,
  ReadonlyPageResponse,
} from '@tabeeb/contracts/main-api/swagger-main-api'

export const ReadonlyWhiteboardKeys = {
  readonlyContent: 'readonlyContent',
}

export interface GetReadonlyPageRequest {
  Token: string
  PageId: number
}

export interface GetReadonlyContentFormRequest {
  Token: string
  ContentFormId: number
}

export interface GetReadonlyFormAnswersByTabRequest {
  Token: string
  ContentFormId: number
  TabIds: number[]
}

const readOnlyWhiteboardPath = 'api/content/shared'

export async function getReadonlyContentRequest({
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<GetReadonlyContentResponse> {
  const [_, token] = queryKey

  const response = await HttpGet<void, GetReadonlyContentResponse>({
    path: `${readOnlyWhiteboardPath}/${token}`,
    unAuthorized: true,
  })

  return response.data
}

export async function getReadonlyPageRequest({
  queryKey,
}: QueryFunctionContext<[string, GetReadonlyPageRequest]>): Promise<ReadonlyPageResponse> {
  const [_, { Token, PageId }] = queryKey

  const response = await HttpGet<void, ReadonlyPageResponse>({
    path: `${readOnlyWhiteboardPath}/${Token}/pages/${PageId}`,
    unAuthorized: true,
  })

  return response.data
}

export async function getReadonlyContentFormRequest({
  queryKey,
}: QueryFunctionContext<[string, GetReadonlyContentFormRequest]>): Promise<GetReadonlyContentFormsResponse> {
  const [_, { Token, ContentFormId }] = queryKey

  const response = await HttpGet<void, GetReadonlyContentFormsResponse>({
    path: `${readOnlyWhiteboardPath}/${Token}/contentForm/${ContentFormId}`,
    unAuthorized: true,
  })

  return response.data
}

export async function getReadonlyFormAnswersByTabRequest({
  queryKey,
}: QueryFunctionContext<[string, GetReadonlyFormAnswersByTabRequest]>): Promise<ReadonlyFormAnswerResponse[]> {
  const [_, { Token, ContentFormId, TabIds }] = queryKey

  const response = await HttpGet<{ tabIds: number[] }, ReadonlyFormAnswerResponse[]>({
    path: `${readOnlyWhiteboardPath}/${Token}/contentForm/${ContentFormId}/tabs`,
    unAuthorized: true,
    params: { tabIds: TabIds },
  })

  return response.data
}
